//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    getShopKeyWord
} from '../../api';
export default {
    data() {
        return {
            searchText: "",
            hotSearch: [],
            isTrue: "",
            historySearchArr: []
        }
    },
    methods: {
        showSearch() {
            this.$emit('search');
            this.$store.commit('hideIsTab');
        },
        getShopKeyWord() {
        },
        onSubmit(msg) { // input 回车搜索
            if (msg) {
                this.$router.push({
                    name: 'search',
                    params: {
                        keyworld: msg
                    }
                });
            }
            if (this.searchText) {
                this.historySearchArr.push(this.searchText);
                this.$router.push({
                    name: 'search',
                    params: {
                        keyworld: this.searchText
                    }
                });
                this.searchText = "";
            }
            this.$emit('searchHide')
        },
        delSearch() { // 删除历史搜索
            this.historySearchArr = [];
        }
    },
    props: ['searchBox'],
    computed: {
        homeScrollTop() {
            return this.$store.state.homeScrollTop;
        },
        searchList() {
            let historySearchArr = this.historySearchArr;
            if (historySearchArr.length > 0) {
                let arr = historySearchArr.slice();
                return arr.reverse();
            } else {
                return "";
            };

        },
        isLogin() {
            return this.$store.state.loginInfo;
        }

    },
    mounted() {
        // this.getShopKeyWord();
        // var histroySearch = localStorage.getItem('histroySearch');
        // if (histroySearch) {
        //     this.historySearchArr = JSON.parse(histroySearch);
        // };
    },
    watch: {
        searchBox(res) {
            if (res) {
                this.$refs.ipt.focus();
                this.getShopKeyWord();
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/components/Home/search.vue